import { render, staticRenderFns } from "./BalletAndDance.vue?vue&type=template&id=1ff3cfbf&scoped=true&"
import script from "./BalletAndDance.vue?vue&type=script&lang=js&"
export * from "./BalletAndDance.vue?vue&type=script&lang=js&"
import style0 from "./BalletAndDance.vue?vue&type=style&index=0&id=1ff3cfbf&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3cfbf",
  null
  
)

export default component.exports